module.exports = __webpack_public_path__ + "img/wenliyundongRight.84b7e7d7.gif";